import axios from 'axios';
import TokenStorage from '@/utils/Token';
import Snackbar from '@/utils/Snackbar';
import router from '@/router';
import store from '@/store';
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Accept'] = 'application/json';

// Add a request interceptor
axios.interceptors.request.use(
  function(config) {
    // startLoader();
    const token = TokenStorage.get();
    if (token) {
      config.headers.common['authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  function(error) {
    // finishLoader();
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
axios.interceptors.response.use(
  function(response) {
    // finishLoader();
    return response;
  },
  async error => {
    // finishLoader();
    let message = 'Something went wrong';
    if (error.response) {
      const data = error.response;
      const {code, success, status} = data || {};
      if (!success) {
        message = data.message;
      }
      if (status === 401 || code === 401) {
        await store.dispatch('auth/logout');
        await router.push('/auth/login');
      }
      if (code === 403) {
        await router.push('/403');
      }
    } else if (error.request) {
      message = error.message;
    } else {
      message = error.message;
    }
    Snackbar.show(message, 'error');
    return Promise.reject(error);
  },
);
